<template>
    <modal name="recommendations-modal" adaptive height="auto">
        
        <b-container class="input-container">
            <b-row v-if="recommendationTaskList.length" class="mb-20 title">
                В данной торговой точке необходимо выполнить задания
            </b-row>

            <b-container v-for="(item, index) in recommendationTaskList" :key="index + 't'" class="recommendation-task"> 
                {{ item.Title }}
                <b-row class="recommendation-task-field">
                    <b-col cols="0">
                        Описание:
                    </b-col>
                    <b-col>
                        {{ item.Description }}
                    </b-col>
                </b-row>
                <b-row class="recommendation-task-field">
                    <b-col cols="0">
                        План:
                    </b-col>
                    <b-col>
                        {{ item.PlannedValue.toFixed(2) }}
                    </b-col>
                </b-row>
                <b-row class="recommendation-task-field">
                    <b-col cols="0">
                        Текущее значение:
                    </b-col>
                    <b-col>
                        {{ item.CurrentValue.toFixed(2) }}
                    </b-col>
                </b-row>
                <b-row class="recommendation-task-field">
                    <b-col cols="0">
                        Крайний срок:
                    </b-col>
                    <b-col>
                        {{ getDateString(item.FinishDate) }}
                    </b-col>
                </b-row>
            </b-container>

            <b-row v-if="recommendationTaskList.length" class="mb-10">
            </b-row>

            <b-row v-if="recommendationList.length" class="mb-20 title">
                В данной торговой точке сформированы рекомендации по ассортименту
            </b-row>

            <b-row v-for="(item, index) in recommendationList" :key="index" class="recommendation"> 
                {{ item.Title }}
                <ul class="recommendation-product">
                    <li v-for="(product, pIndex) in item.Products" :key="pIndex">
                        {{ product }}
                    </li>
                </ul>
            </b-row>

            <b-row v-if="recommendationList.length" class="mb-10">
            </b-row>

            <b-row class="m-0">
                <b-button block 
                          variant="outline-primary"
                          class="button-save"
                          @click="hideModal">
                    Закрыть
                </b-button>
            </b-row>

        </b-container>

    </modal>
</template>

<script>
import '@/assets/styles/client/tradePoints/recommendationsModal.css'

export default {
    props: {
        recommendationList: {
          type: Array,
          default: () => []
        },
        recommendationTaskList: {
          type: Array,
          default: () => []
        }
    },
    methods: {
        hideModal: function() {
            this.$modal.hide('recommendations-modal');
        },
        getDateString(value) {
            value = new Date(value);
            const date = `${value.getDate()}`.length == 1
                            ? `0${value.getDate()}`
                            : value.getDate();

            const month = `${value.getMonth() + 1}`.length == 1
                            ? `0${value.getMonth() + 1}`
                            : value.getMonth() + 1;

            const year = value.getFullYear();

            return `${date}.${month}.${year}`;
        },
    }
}
</script>